import type { v2 } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule } from '../../../common/decoration';
import {
    addPatternForBindingChangeOfEnumOP,
    convertSectionId,
    getActionBreadcrumbParts,
    convertActionKeyToStableId
} from '../../../common';
import type { ButtonType } from 'sap/m/library';
import type { URI } from 'sap/ui/core/library';

/**
 * Creates a stable ID for the Object Page Toolbar Action button.
 *
 * @param {string} baseId - The base ID of the control.
 * @param {string[]} _idBreadcrumbs - The breadcrumbs for the ID.
 * @param {string[]} breadcrumbs - The breadcrumbs for the action.
 * @param _controlType - The control type (not used in this function).
 * @param {string} facetID - The title from the app schema, typically comprising the facet ID.
 * @returns {string} stable ID of Object Page Toolbar Action button
 */
const getActionButtonId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType,
    facetID: string
): string => {
    const { actionId } = getActionBreadcrumbParts(breadcrumbs);
    const section = convertSectionId(breadcrumbs[1], facetID);
    return `${baseId}${section}::action::${convertActionKeyToStableId(actionId).replace(':2f', '::')}`;
};

const flexRuleForToolBarActionOP = {
    controlId: getActionButtonId,
    controlType: (): ControlType => ControlType.Button
};

export class ObjectPageToolBarAction implements v2.ObjectPageToolBarAction {
    @syncRule({
        flex: flexRuleForToolBarActionOP,
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible: boolean;

    @syncRule({
        flex: flexRuleForToolBarActionOP
    })
    tooltip?: string;

    @syncRule({
        flex: flexRuleForToolBarActionOP
    })
    icon?: URI;

    @syncRule({
        flex: flexRuleForToolBarActionOP
    })
    activeIcon?: URI;

    @syncRule({
        flex: flexRuleForToolBarActionOP
    })
    type?: ButtonType;
}
